<span>
  {{ _date | date: 'dd/MM/yyyy' }}
  @if (showTime) {
    <span>{{ _date | date: 'HH:MM' }}</span>
  }
</span>
